export default {
  addReportSuccessMessage: 'tests.addReportSuccessMessage',
  addReportErrorMessage: 'tests.addReportErrorMessage',
  buttonText: 'tests.addReport',
  textareaLabel: 'tests.report',
  inputLabel: 'tests.doctorName'
};
